export const selectAllHandler = (
  data,
  name,
  isLocationSelected,
  isSpecificLocationSelected,
  isAllSelected
) => {
  const select = !isAllSelected;

  const locationDispatchObj = {
    controller: name,
    arr: isLocationSelected.map(() => select),
  };

  const specLocationDispatchObj = {
    controller: name,
    arr: isSpecificLocationSelected.map((el) => el.map(() => select)),
  };

  const individualArr = Object.values(data || {}).map((location) => {
    if (location?.isSpecificLocation) {
      return Object.values(location.subLocations || {}).map((subLocation) =>
        Object.keys(subLocation?.devices || subLocation || {}).map(() => select)
      );
    }

    return Object.keys(location?.devices || location || {}).map(() => select);
  });

  return {
    locationList: locationDispatchObj,
    specificLocationList: specLocationDispatchObj,
    machineList: {
      controller: name,
      arr: individualArr,
    },
    select,
  };
};
